<app-loading-wrapper [loading]="saving">
    <div *ngIf="questions && formGroup">
        <form *ngIf="questions" [formGroup]="formGroup">

            <mat-card *ngIf="formTermHasBeenLoaded">
                <mat-card-title>{{addEditText}} Grading Schedule</mat-card-title>

                <div class="row">
                    <div class="small-12 medium-12 large-2 columns">
                        <app-question [question]="questions.termCode" (controlValueChange)="updateSelectATerm($event)"></app-question>
                    </div>

                    <div class="small-12 medium-6 large-3 columns">
                        <app-question [question]="questions.termStartDate"></app-question>

                    </div>
                    <div class="small-12 medium-6 large-3 columns">
                        <app-question [question]="questions.openDate"></app-question>
                    </div>

                    <div class="small-12 medium-12 large-2 columns">
                        <app-question [question]="questions.numberTimeAllowedGradeChange"></app-question>
                    </div>
                    <div class="small-12 medium-12 large-2 columns">
                        <app-question [question]="questions.enabled"></app-question>
                    </div>
                </div>
                <div class="row">
                    <div class="small-12 medium-12 large-12 columns">
                        <app-button-list>
                            <app-button [loading]="saving" *ngIf="onShowSaveButton()" (clickedEvent)="saveUpdateData()">{{saveUpdateText}} </app-button>
                            <app-button [loading]="saving" (clickedEvent)="onCancel()">Cancel </app-button>
                        </app-button-list>
                    </div>
                </div>




            </mat-card>








        </form>

    </div>
</app-loading-wrapper>

<!---

<mat-card *ngIf="formTermHasBeenLoaded">
    <mat-card-title>{{addEditText}} Grading Schedule</mat-card-title>

    <div class="row">
        <div class="small-12 medium-12 large-3 columns">
            <mat-card-subtitle>Select a Term</mat-card-subtitle>
            <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="tempGradingSchedule.termCode" (selectionChange)="updateSelectATerm($event)">
                    <mat-option *ngFor="let term of termList" [value]="term.value" >
                        {{term.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="small-12 medium-6 large-3 columns">
            <mat-card-subtitle>Term Open Date</mat-card-subtitle>
            <mat-form-field appearance="fill">
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="pickerSD" [(ngModel)]="tempGradingSchedule.termStartDate">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="pickerSD"></mat-datepicker-toggle>
                <mat-datepicker #pickerSD startView="month" [startAt]="tempGradingSchedule.termStartDate"></mat-datepicker>
            </mat-form-field>

        </div>
        <div class="small-12 medium-6 large-3 columns">
            <mat-card-subtitle>Grading Open</mat-card-subtitle>
            <mat-form-field appearance="fill">
                <mat-label>Choose a date & time</mat-label>
                <input matInput [matDatepicker]="pickerOD" [(ngModel)]="tempGradingSchedule.openDate">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="pickerOD"></mat-datepicker-toggle>
                <mat-datepicker #pickerOD startView="month" [startAt]="tempGradingSchedule.openDate"></mat-datepicker>
            </mat-form-field>


        </div>

        <div class="small-12 medium-12 large-2 columns">
            <mat-card-subtitle>Number of Grade Change</mat-card-subtitle>
            <mat-form-field appearance="fill">
                <input matInput [(ngModel)]="tempGradingSchedule.numberTimeAllowedGradeChange">
            </mat-form-field>

        </div>
    </div>
    <app-button-list>
        <app-button [loading]="saving" (clickedEvent)="saveUpdateData()">{{saveUpdateText}} </app-button>
        <app-button [loading]="saving" (clickedEvent)="onCancel()">Cancel </app-button>
    </app-button-list>



</mat-card>
-->